import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { ExportTypeDropdown } from 'Common/ExportTypeDropdown';
import { CLOSE_SCHOOL_YEAR_DOWNLOAD_ROSTER_FORM_NAME } from 'Common/FormEnum';

class DownloadRosterForm extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <React.Fragment>
        <Form>
          <ExportTypeDropdown />

          <Button
            primary
            loading={this.props.loading}
            onClick={this.props.submit}
          >
            Download
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}

export default reduxForm({
  form: CLOSE_SCHOOL_YEAR_DOWNLOAD_ROSTER_FORM_NAME,
  enableReinitialize: true,
})(DownloadRosterForm);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/components/DownloadRosterForm.js